import React, { Component } from "react";
import NotDividedList from "../../components/schedule/NotDividedList";
import { languages } from "../../constants/languages";
import { getTeamName } from "../../util/GetTeamName";

class NotPlannedContainer extends Component {
  filterMatchesByTeam = (matches) => {
    const searchTerm = this.props.teamSearch.toLowerCase();
    if (!searchTerm) return matches;

    return matches.filter((match) => {
      const team1 = getTeamName(
        match,
        this.props.poulesByKey,
        this.props.teamsByKey,
        this.props.teams,
        this.props.resultSpotsAll,
        this.props.divisionsObject,
        this.props.bracketsByKey,
        1
      );

      const team2 = getTeamName(
        match,
        this.props.poulesByKey,
        this.props.teamsByKey,
        this.props.teams,
        this.props.resultSpotsAll,
        this.props.divisionsObject,
        this.props.bracketsByKey,
        2
      );

      return (
        team1.toLowerCase().includes(searchTerm) ||
        team2.toLowerCase().includes(searchTerm)
      );
    });
  };

  render() {
    let options = [];
    let optionsUsed = [];
    let allMatchesPlanned = true;
    for (let i = 0; i < this.props.matches.length; i++) {
      let match = this.props.matches[i];
      if (match.field === null || match.field === "empty") {
        allMatchesPlanned = false;
      }
      let poule = this.props.poulesByKey[match.poule] || {};
      let bracket = this.props.bracketsByKey[poule.bracket] || {};
      let division = this.props.divisionsObject[poule.division] || {};
      if (optionsUsed.indexOf(match.poule) === -1) {
        optionsUsed.push(match.poule);
        options.push({
          value: match.poule,
          label:
            (poule.name || "") +
            (this.props.divisions.length > 1
              ? " - " + (division.name || "")
              : ""),
          division: poule.division,
          fase: poule.fase,
          num: poule.num,
          indexNum: poule.indexNum,
          bracketNum: bracket.num !== undefined ? bracket.num : poule.num,
          isPoule: !poule.singleMatch,
        });
      }

      if (this.props.divisions.length > 1) {
        if (optionsUsed.indexOf(poule.division) === -1) {
          optionsUsed.push(poule.division);
          options.push({
            value: poule.division,
            label: division.name || "",
            division: poule.division,
            fase: -1,
          });
        }
      }

      if (poule.bracket) {
        if (optionsUsed.indexOf(poule.bracket) === -1) {
          optionsUsed.push(poule.bracket);
          options.push({
            value: poule.bracket,
            label:
              (bracket.name || "") +
              (this.props.divisions.length > 1
                ? " - " + (division.name || "")
                : ""),
            division: poule.division,
            fase: bracket.fase,
            num: -1,
            indexNum: bracket.indexNum,
            bracketNum: bracket.num,
          });
        }
      }
    }
    options.sort((a, b) => {
      if (a.division > b.division) {
        return 1;
      } else if (a.division < b.division) {
        return -1;
      } else if (a.fase > b.fase) {
        return 1;
      } else if (a.fase < b.fase) {
        return -1;
      } else if (a.indexNum > b.indexNum) {
        return 1;
      } else if (a.indexNum < b.indexNum) {
        return -1;
      } else if (a.bracketNum > b.bracketNum) {
        return 1;
      } else if (a.bracketNum < b.bracketNum) {
        return -1;
      } else if (a.num > b.num) {
        return 1;
      } else if (a.num < b.num) {
        return -1;
      } else {
        return 0;
      }
    });

    let showSelectRounds = false;
    let selectedPouleId = null;
    if (this.props.selected.length === 1) {
      this.props.selected.forEach((s) => {
        if (s.isPoule) {
          showSelectRounds = true;
          selectedPouleId = s.value;
        }
      });
    }

    let roundsCounter = [];
    let roundOptions = [];
    if (selectedPouleId) {
      const matches = this.props.matches.filter(
        (match) => match.poule === selectedPouleId
      );
      for (let m in matches) {
        const match = matches[m];
        if (roundsCounter.indexOf(match.round) === -1) {
          roundOptions.push({
            value: match.round,
            label: languages.schedule.round + " " + Number(match.round + 1),
          });
          roundsCounter.push(match.round);
        }
      }
    }
    roundOptions.sort((a, b) => a.value - b.value);
    roundOptions.unshift({ value: "all", label: languages.schedule.allRounds });

    return (
      <NotDividedList
        {...this.props}
        matchesToPlan={this.filterMatchesByTeam(
          this.props.matches.filter((match) => {
            if (this.props.selected.length > 0) {
              let matchSelected = false;
              let selectedKeys = this.props.selected.map((s) => s.value);

              if (selectedKeys.indexOf(match.poule) > -1) {
                matchSelected = true;
                if (showSelectRounds) {
                  if (
                    this.props.selectedRoundFilter !== "all" &&
                    match.round !== this.props.selectedRoundFilter
                  ) {
                    matchSelected = false;
                  }
                }
              } else {
                let poule = this.props.poulesByKey[match.poule] || {};
                if (selectedKeys.indexOf(poule.division) > -1) {
                  matchSelected = true;
                } else if (poule.bracket) {
                  if (selectedKeys.indexOf(poule.bracket) > -1) {
                    matchSelected = true;
                  }
                }
              }
              return (
                (match.field === null || match.field === "empty") &&
                matchSelected
              );
            } else {
              return match.field === null || match.field === "empty";
            }
          })
        )}
        teamSearch={this.props.teamSearch}
        handleTeamSearch={this.props.handleTeamSearch}
        handleSelectChange={this.props.handleSelectChangeNotPlanned}
        value={this.props.selected}
        options={options}
        divisionColors={this.props.divisionColors}
        groupColors={this.props.groupColors}
        allMatchesPlanned={allMatchesPlanned}
        selectedRoundFilter={this.props.selectedRoundFilter}
        showSelectRounds={showSelectRounds}
        roundOptions={roundOptions}
        handleSelectRoundChange={this.props.handleSelectRoundChange}
      />
    );
  }
}

export default NotPlannedContainer;
